export type Role = 'mover' | 'team_lead' | 'sales' | 'manager' | 'admin' | 'super_admin' | 'developer' | 'other'

export enum RoleEnum {
  mover = 'mover',
  team_lead = 'team_lead',
  sales = 'sales',
  manager = 'manager',
  admin = 'admin',
  super_admin = 'super_admin',
  developer = 'developer',
  other = 'other',
}

export type RoleGroup = Role[]

export const ADMIN_ONLY: RoleGroup = [RoleEnum.admin]
export const SUPER_ADMIN_ONLY: RoleGroup = [RoleEnum.super_admin]
export const ADMIN_AND_MANAGER: RoleGroup = [RoleEnum.admin, RoleEnum.manager]
export const ADMIN_MANAGER_SALES: RoleGroup = [RoleEnum.admin, RoleEnum.manager, RoleEnum.sales]
export const ADMIN_SALES_MANAGER: RoleGroup = [RoleEnum.admin, RoleEnum.sales, RoleEnum.manager]
export const ALL_OFFICE_ROLES: RoleGroup = [
  RoleEnum.admin,
  RoleEnum.manager,
  RoleEnum.sales,
  RoleEnum.team_lead,
  RoleEnum.mover,
]
export const FIELD_ROLES: RoleGroup = [RoleEnum.mover, RoleEnum.team_lead]
export const SALES_AND_MANAGER: RoleGroup = [RoleEnum.sales, RoleEnum.manager]

export const ALL_EMPLOYEE_ROLES: RoleGroup = [
  RoleEnum.mover,
  RoleEnum.team_lead,
  RoleEnum.sales,
  RoleEnum.manager,
  RoleEnum.admin,
]

export const ALL_EMPLOYEE_ROLES_WITH_OTHER: RoleGroup = [
  RoleEnum.mover,
  RoleEnum.team_lead,
  RoleEnum.sales,
  RoleEnum.manager,
  RoleEnum.admin,
  RoleEnum.other,
]
